export const PROJECT_NAME = 'granted_accesses'
